/* ============================================================
 * samurai-ketsudan.js（自動生成ファイル・直接編集しない）
 * 生成元: shindan_proto/ ／ 再生成: node shindan_shopify/build_shopify.js
 * 生成日時: 2026-10-12T13:11:36.915Z
 * ============================================================ */

/* ---- js/engine.js ---- */
// 判定エンジン（純関数のみ・UI非依存）
// 仕様: 共有用_診断設計全体サマリー.md（2026-07-19確定）
window.SHINDAN = window.SHINDAN || {};
(function () {
  "use strict";
  const S = window.SHINDAN;

  function cfg() { return S.config; }
  function axesOrder() { return S.axes.order; }

  // 回答から6軸ユーザーベクトルと信頼度を算出
  // answers: { qid(Number): optionKey(String) }
  function computeVector(answers) {
    const acc = {};
    for (const k of axesOrder()) {
      acc[k] = [[cfg().neutralPrior.value, cfg().neutralPrior.weight]];
    }
    for (const q of S.questions) {
      const key = answers[q.id];
      if (!key) continue;
      const opt = q.options.find(o => o.key === key);
      if (!opt) continue;
      for (const [axis, val, w] of opt.scoring) acc[axis].push([val, w]);
    }
    const vec = {}, conf = {};
    for (const k of axesOrder()) {
      const tw = acc[k].reduce((s, x) => s + x[1], 0);
      vec[k] = acc[k].reduce((s, x) => s + x[0] * x[1], 0) / tw;
      conf[k] = Math.min(tw, cfg().confCap);
    }
    return { vec, conf };
  }

  function similarity(vec, conf, profile) {
    let num = 0, den = 0;
    axesOrder().forEach((k, i) => {
      num += conf[k] * Math.abs(vec[k] - profile[i]);
      den += conf[k];
    });
    return 100 * (1 - num / (4 * den));
  }

  function entryScore(entranceId, warlordId) {
    const ent = S.entrances.find(e => e.id === entranceId);
    if (!ent) return cfg().entryScores.other;
    if (ent.primary.includes(warlordId)) return cfg().entryScores.primary;
    if (ent.secondary.includes(warlordId)) return cfg().entryScores.secondary;
    return cfg().entryScores.other;
  }

  // 分布補正: mode "A"=0 / "B"=そのまま / "C"=±clampに制限
  function correction(warlord, mode) {
    if (mode === "A") return 0;
    if (mode === "C") {
      const c = cfg().correctionClampC;
      return Math.max(-c, Math.min(c, warlord.offset));
    }
    return warlord.offset; // "B"
  }

  // メイン判定
  // 戻り値: { winner, needTiebreak, tiePair, rows(全26明細・得点降順), vec, conf,
  //           lowSimilarityFallback }
  function diagnose(entranceId, answers, mode) {
    const { vec, conf } = computeVector(answers);
    const rows = S.warlords.map(w => {
      const sim = similarity(vec, conf, w.profile);
      const ent = entryScore(entranceId, w.id);
      const corr = correction(w, mode);
      return {
        id: w.id, name: w.name, sim, entry: ent, corr,
        score: cfg().weights.similarity * sim + cfg().weights.entry * ent + corr
      };
    }).sort((a, b) => b.score - a.score);

    const top1 = rows[0], top2 = rows[1];
    let lowSimilarityFallback = false;
    let winner = top1.id;
    let needTiebreak = false;
    let tiePair = null;

    if (top1.sim < cfg().minSimilarity) {
      // どの武将プロフィールとも十分に近くない → 入口候補群（主要+準）の中の最上位
      // ※「回答が矛盾している」ことを意味しない（保険的処理。全パターン検証で勝者変更0件）
      lowSimilarityFallback = true;
      const ent = S.entrances.find(e => e.id === entranceId);
      const pool = ent ? ent.primary.concat(ent.secondary) : [];
      const inPool = rows.filter(r => pool.includes(r.id));
      if (inPool.length) winner = inPool[0].id;
    } else if (top1.score - top2.score < cfg().tieGap) {
      needTiebreak = true;
      tiePair = [top1.id, top2.id];
    }
    return { winner, needTiebreak, tiePair, rows, vec, conf, lowSimilarityFallback };
  }

  // 追加質問の選定: ペア専用があればそれ、なければ差が最大の軸の汎用質問
  // 戻り値: { type:"pair"|"generic", text, options:[{key,text,winnerId}], axis? , reason }
  function pickTiebreakQuestion(idA, idB) {
    const pair = S.tiebreaks.pairs.find(p =>
      (p.a === idA && p.b === idB) || (p.a === idB && p.b === idA));
    if (pair) {
      return {
        type: "pair",
        text: pair.text,
        options: [
          { key: "a", text: pair.optA, winnerId: pair.a },
          { key: "b", text: pair.optB, winnerId: pair.b }
        ],
        reason: "ペア専用質問（" + nameOf(pair.a) + "／" + nameOf(pair.b) + "）"
      };
    }
    const wa = byId(idA), wb = byId(idB);
    let maxDiff = -1, axisIdx = 0;
    axesOrder().forEach((k, i) => {
      const d = Math.abs(wa.profile[i] - wb.profile[i]);
      if (d > maxDiff) { maxDiff = d; axisIdx = i; }
    });
    const axis = axesOrder()[axisIdx];
    const g = S.tiebreaks.generic[axis];
    // optLow(値1側)は、その軸の値が小さい方の武将
    const lowId = wa.profile[axisIdx] <= wb.profile[axisIdx] ? idA : idB;
    const highId = lowId === idA ? idB : idA;
    return {
      type: "generic", axis,
      text: g.text,
      options: [
        { key: "low", text: g.optLow, winnerId: lowId },
        { key: "high", text: g.optHigh, winnerId: highId }
      ],
      reason: "汎用質問（差が最大の軸: " + axis + "＝" + S.axes.defs[axis].name +
              "、差" + maxDiff + "）"
    };
  }

  function byId(id) { return S.warlords.find(w => w.id === id); }
  function nameOf(id) { const w = byId(id); return w ? w.name : id; }

  // 3モード比較（デバッグ用）
  function compareModes(entranceId, answers) {
    const out = {};
    for (const m of ["A", "B", "C"]) out[m] = diagnose(entranceId, answers, m);
    return out;
  }

  S.engine = {
    computeVector, similarity, entryScore, correction,
    diagnose, pickTiebreakQuestion, compareModes, byId, nameOf
  };
})();

/* ---- js/reason.js ---- */
// 結果理由の生成（実際の回答のみを根拠にする）v0.2
// 方針（ChatGPTレビュー反映）:
//   1. 軸別定型文は使わず、選択肢ごとの reasonText を使用
//   2. 「勝者に近い」だけでなく「2位との差を生んだ」回答（判別寄与度）を優先
//   3. 追加質問を使った場合は、その回答を理由の最初に表示
//   4. 差を生んだ回答がない場合は断定せず、回答全体の傾向と説明する
window.SHINDAN = window.SHINDAN || {};
(function () {
  "use strict";
  const S = window.SHINDAN;

  // 戻り値: { lines: [文…], picked: [{qid, optionKey, optionText, axis,
  //           alignWinner, alignRunnerUp, contrib}], usedFallbackNote }
  function buildReason(entranceId, answers, winnerId, runnerUpId, tiebreak) {
    const w = S.engine.byId(winnerId);
    const r = runnerUpId ? S.engine.byId(runnerUpId) : null;
    const axisIdx = {}; S.axes.order.forEach((k, i) => axisIdx[k] = i);
    const cands = [];

    for (const q of S.questions) {
      const key = answers[q.id];
      if (!key) continue;
      const opt = q.options.find(o => o.key === key);
      if (!opt || !opt.scoring.length) continue;
      // 主配点（先頭）で評価
      const [axis, val] = opt.scoring[0];
      const alignWinner = 1 - Math.abs(val - w.profile[axisIdx[axis]]) / 4;
      const alignRunnerUp = r ? 1 - Math.abs(val - r.profile[axisIdx[axis]]) / 4 : 0;
      cands.push({
        qid: q.id, optionKey: key, optionText: opt.text,
        reasonText: opt.reasonText || "", axis,
        alignWinner, alignRunnerUp,
        contrib: alignWinner - alignRunnerUp   // 判別寄与度
      });
    }

    // 1) 2位との差を生み、かつ勝者と十分近い回答を優先
    const discriminating = cands
      .filter(c => c.contrib >= 0.1 && c.alignWinner >= 0.5)
      .sort((a, b) => b.contrib - a.contrib || b.alignWinner - a.alignWinner);
    let picked = discriminating.slice(0, 2);
    let usedFallbackNote = false;

    // 2) 差を生んだ回答がない場合：一致度最上位1件のみ＋断定しない文
    if (!picked.length) {
      usedFallbackNote = true;
      const best = [...cands].sort((a, b) => b.alignWinner - a.alignWinner)[0];
      if (best && best.alignWinner >= 0.5) picked = [best];
    }

    const lines = [];
    // 追加質問を使った場合は最初に表示
    if (tiebreak && tiebreak.answeredText) {
      lines.push("最後の質問で「" + tiebreak.answeredText + "」を選んだことが、" +
        w.name + "を選ぶ決め手になりました。");
    }
    for (const p of picked) {
      lines.push("あなたはQ" + p.qid + "で「" + p.optionText + "」を選びました。" +
        p.reasonText + "回答です。");
    }
    if (usedFallbackNote) {
      lines.push("一つの回答だけで決まったのではなく、7つの回答全体の傾向から、" +
        w.name + "が選ばれました。");
    }
    return { lines, picked, usedFallbackNote };
  }

  S.reason = { buildReason };
})();

/* ---- js/logger.js ---- */
// 匿名ログ（localStorage保存・JSON/CSV書き出し）
// 個人情報・氏名・メールアドレスは一切取得しない
window.SHINDAN = window.SHINDAN || {};
(function () {
  "use strict";
  const S = window.SHINDAN;
  const KEY_LOGS = "shindan_logs_v02";
  const KEY_STATE = "shindan_state_v02";
  // 完了した診断結果（芳名帳用）。氏名・メールアドレスは保存しない。
  const KEY_RESULT = "shindan_result_v02";
  // v0.1の旧データがv0.2へ混ざらないよう、初回起動時に旧キーを削除
  try {
    localStorage.removeItem("shindan_logs_v01");
    localStorage.removeItem("shindan_state_v01");
  } catch (e) { /* localStorage無効環境では何もしない */ }

  function now() { return Date.now(); }
  function uid() {
    return "s" + now().toString(36) + Math.random().toString(36).slice(2, 8);
  }
  function safeGet(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function safeSet(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* 容量超過等は無視 */ }
  }

  // ---- セッション（進行状態の保存・復元）----
  function saveState(state) { safeSet(KEY_STATE, state); }
  function loadState() { return safeGet(KEY_STATE, null); }
  function clearState() { try { localStorage.removeItem(KEY_STATE); } catch (e) {} }

  // ---- 完了した診断結果（芳名帳用・再読み込みしても正しい武将を復元するため）----
  // 保存するのは入口・回答・結果IDと完了時刻のみ。個人情報は一切保存しない。
  function saveResult(result) { safeSet(KEY_RESULT, result); }
  function loadResult() { return safeGet(KEY_RESULT, null); }
  function clearResult() { try { localStorage.removeItem(KEY_RESULT); } catch (e) {} }
  // 芳名登録が済んだ結果に印を付ける（同じ結果での二重登録を防ぐ）
  function markResultRegistered() {
    const r = loadResult();
    if (r) { r.registered = true; saveResult(r); }
  }

  // ---- イベントログ ----
  function newSession(mode, appMode) {
    return {
      sessionId: uid(),
      logicVersion: S.config.version,
      correctionMode: mode,
      appMode: appMode || "",
      startedAt: now(),
      events: []   // {t, type, data}
    };
  }
  function logEvent(session, type, data) {
    if (!session) return;
    session.events.push({ t: now(), type, data: data || null });
  }
  function commitSession(session) {
    if (!session) return;
    const logs = safeGet(KEY_LOGS, []);
    // 同一sessionIdは上書き（途中保存→完了時更新のため）
    const i = logs.findIndex(l => l.sessionId === session.sessionId);
    if (i >= 0) logs[i] = session; else logs.push(session);
    safeSet(KEY_LOGS, logs);
  }
  function allLogs() { return safeGet(KEY_LOGS, []); }
  function clearLogs() { try { localStorage.removeItem(KEY_LOGS); } catch (e) {} }

  // ---- 集計（1セッション=1行に平坦化）----
  function flatten(session) {
    const ev = t => session.events.filter(e => e.type === t);
    const first = t => ev(t)[0] || null;
    // 入口・追加質問回答は「最後の」選択を採用（戻って選び直した場合に対応）
    const last = t => { const list = ev(t); return list[list.length - 1] || null; };
    const answers = {};
    ev("answer").forEach(e => { answers["Q" + e.data.qid] = e.data.optionKey; });
    // 回答を変更して再完了した場合も、最後に表示された結果を記録する
    const complete = last("complete");
    // 離脱位置は最後に表示していた画面名（screen_viewイベント）で記録
    const lastScreen = last("screen_view");
    const survey = last("survey_submit");
    const sv = survey ? survey.data : {};
    return {
      sessionId: session.sessionId,
      logicVersion: session.logicVersion,
      correctionMode: session.correctionMode,
      appMode: session.appMode || "",
      startedAt: new Date(session.startedAt).toISOString(),
      entrance: last("entrance_select") ? last("entrance_select").data.entranceId : "",
      Q1: answers.Q1 || "", Q2: answers.Q2 || "", Q3: answers.Q3 || "",
      Q4: answers.Q4 || "", Q5: answers.Q5 || "", Q6: answers.Q6 || "",
      Q7: answers.Q7 || "",
      tiebreakShown: ev("tiebreak_shown").length > 0,
      tiebreakAnswer: last("tiebreak_answer") ? last("tiebreak_answer").data.optionKey : "",
      completed: !!complete,
      resultWarlord: complete ? complete.data.winnerId : "",
      dropPosition: complete ? "" : (lastScreen ? lastScreen.data.screen : "start"),
      resultViewed: ev("result_view").length > 0,
      mapTapped: ev("map_tap").length > 0,
      saveTapped: ev("save_tap").length > 0,
      shopTapped: ev("shop_tap").length > 0,
      shareTapped: ev("share_tap").length > 0,
      durationSec: complete ? Math.round((complete.t - session.startedAt) / 1000) : "",
      // テスト後アンケート（testモードのみ。判定には無関係）
      surveyS1: sv.s1 || "", surveyS2: sv.s2 || "", surveyS3: sv.s3 || "",
      surveyS4: sv.s4 || "", surveyS5: sv.s5 || "",
      surveyS5Items: (sv.s5items || []).join("|")
    };
  }

  function exportJSON() {
    return JSON.stringify({ exportedAt: new Date().toISOString(),
      logicVersion: S.config.version, sessions: allLogs() }, null, 2);
  }
  function exportCSV() {
    const rows = allLogs().map(flatten);
    if (!rows.length) return "";
    const headers = Object.keys(rows[0]);
    const esc = v => '"' + String(v).replace(/"/g, '""') + '"';
    return [headers.join(","),
      ...rows.map(r => headers.map(h => esc(r[h])).join(","))].join("\n");
  }
  function download(filename, text, mime) {
    const blob = new Blob([text], { type: mime || "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a); a.click();
    setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 500);
  }

  S.logger = {
    newSession, logEvent, commitSession, allLogs, clearLogs, flatten,
    exportJSON, exportCSV, download,
    saveState, loadState, clearState,
    saveResult, loadResult, clearResult, markResultRegistered
  };
})();

/* ---- js/guestbook.js ---- */
// 芳名帳（個展の来場記録）— 入力チェックと送信 v0.4
// 方針:
//   1. 武将は送信しない。サーバー（GAS）が入口・回答から再判定して保存する。
//      画面の値を書き換えても、別の武将として登録することはできない。
//   2. 診断が完了していない場合は登録できない（結果が保存されていない＝送信不可）。
//   3. 通信に失敗したときは登録済みにしない。サーバーは診断セッションIDで重複を排除するため、
//      同じ結果で送り直しても行は増えない。
//   4. 氏名・メールアドレスはコンソールへ出力しない。
window.SHINDAN = window.SHINDAN || {};
(function () {
  "use strict";
  const S = window.SHINDAN;

  function cfg() { return (S.config && S.config.guestbook) || {}; }

  // 登録フォームを表示してよいか（設定・送信先・診断完了の3条件）
  // test/exhibition は芳名帳（来場記録）、public は結果メール・新作案内の登録として表示する。
  function isAvailable(appMode, hasResult) {
    const g = cfg();
    return !!(g.enabled && g.endpointUrl && hasResult);
  }

  // 保存された診断結果が、まだ芳名登録に使えるか（未登録かつ保持時間内）
  function isResultUsable(result) {
    if (!result || !result.resultId) return false;
    if (result.registered) return false;
    const hours = cfg().resultTtlHours || 6;
    return (Date.now() - (result.completedAt || 0)) < hours * 3600 * 1000;
  }

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // 入力チェック。戻り値: { ok, name, email, consent } または { ok:false, error }
  function validate(rawName, rawEmail, rawConsent) {
    const name = String(rawName == null ? "" : rawName).trim();
    const email = String(rawEmail == null ? "" : rawEmail).trim();
    const max = cfg().nameMaxLength || 40;
    if (!name) return { ok: false, error: "お名前をご入力ください。" };
    if (name.length > max) {
      return { ok: false, error: "お名前は" + max + "文字以内でご入力ください。" };
    }
    if (email && !EMAIL_RE.test(email)) {
      return { ok: false, error: "メールアドレスの形式をご確認ください。" };
    }
    if (rawConsent && !email) {
      return { ok: false, error: "案内を受け取るにはメールアドレスをご入力ください。" };
    }
    // メールアドレスがない場合は同意そのものが成立しないため false に丸める
    return { ok: true, name, email, consent: !!(rawConsent && email) };
  }

  // 送信内容。武将IDは含めない。
  // clientResultId は照合専用（サーバーはこの値を保存の根拠にしない）。
  function buildPayload(result, input) {
    return {
      type: "guestbook",
      sessionId: result.sessionId,
      entranceId: result.entranceId,
      answers: result.answers,
      tiebreakAnswerKey: result.tiebreakAnswerKey || "",
      correctionMode: result.correctionMode,
      completedAt: new Date(result.completedAt).toISOString(),
      appMode: result.appMode || "",
      logicVersion: S.config.version,
      appVersion: S.config.appVersion,
      dataFingerprint: S.config.dataFingerprint || "",
      clientResultId: result.resultId,
      name: input.name,
      email: input.email,
      consent: input.consent
    };
  }

  // 送信。戻り値は Promise<{ ok, mailSent, warlordName, error }>
  // Content-Type は text/plain（GASウェブアプリが受け取れる形式。プリフライトも起きない）。
  function submit(result, input) {
    const url = cfg().endpointUrl;
    if (!url) return Promise.reject(new Error("endpoint_not_configured"));
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain;charset=utf-8" },
      body: JSON.stringify(buildPayload(result, input)),
      redirect: "follow"
    }).then(res => res.json());
  }

  S.guestbook = { isAvailable, isResultUsable, validate, buildPayload, submit };
})();

/* ---- js/app.js ---- */
// 画面フロー・状態管理・結果表示・保存画像・デバッグ画面 v0.2
window.SHINDAN = window.SHINDAN || {};
(function () {
  "use strict";
  const S = window.SHINDAN;
  const $ = sel => document.querySelector(sel);
  const app = $("#app");

  // ---- グローバル状態 ----
  const params = new URLSearchParams(location.search);
  const DEBUG = params.get("debug") === "1";
  let mode = (params.get("mode") || S.config.defaultCorrectionMode).toUpperCase();
  if (!["A", "B", "C"].includes(mode)) mode = "A";
  // 三段階運用モード（表示のみ切替。判定には一切影響しない）
  // 優先順: URLパラメータ（?debug=1 のときだけ有効） → Shopifyテンプレートのwindow.SKD_APP_MODE → config
  // ?appmode= を運営以外に効かせない。会期終了後も ?appmode=exhibition で
  // 展示位置つきの画面・保存画像が出てしまうため（2026-10-12）。
  // 運営が確認するときは ?appmode=exhibition&debug=1 のように debug とセットで付ける。
  let appMode = ((DEBUG && params.get("appmode")) || window.SKD_APP_MODE ||
                 S.config.appMode || "test").toLowerCase();
  if (!["test", "exhibition", "public"].includes(appMode)) appMode = "test";

  let state = null;    // { screen, entranceId, answers{}, tiebreak{}, resultId, runnerUpId }
  let session = null;  // ログセッション
  let suppressPush = false;   // popstate復帰時はpushStateしない
  let lastPushedScreen = null;

  function freshState() {
    return { screen: "start", entranceId: null, answers: {},
             tiebreak: null, resultId: null, runnerUpId: null,
             survey: null, sessionSnapshot: null };
  }

  function persist() {
    state.sessionSnapshot = session;
    // 診断完了後（結果・マップ）は途中復元の対象にしない
    if (state.resultId) S.logger.clearState();
    else S.logger.saveState({ state, mode });
    if (session) S.logger.commitSession(session);
  }

  // ---- 起動時の復元 ----
  function boot() {
    history.replaceState({ screen: "start", shindan: true }, "");
    const saved = S.logger.loadState();
    if (saved && saved.state && saved.state.screen !== "start" &&
        saved.state.screen !== "result") {
      state = saved.state;
      mode = saved.mode || mode;
      session = saved.state.sessionSnapshot || S.logger.newSession(mode, appMode);
      renderResume();
      return;
    }
    // 診断完了後に再読み込みした場合:
    // 芳名登録がまだで保持時間内なら、保存した結果から結果画面を復元する
    // （画面の値ではなく保存データから武将を戻すため、常に正しい武将になる）。
    const done = S.logger.loadResult();
    if (S.guestbook.isAvailable(appMode, !!(done && done.resultId)) &&
        S.guestbook.isResultUsable(done) && S.engine.byId(done.resultId)) {
      state = freshState();
      state.entranceId = done.entranceId;
      state.answers = done.answers || {};
      state.resultId = done.resultId;
      state.runnerUpId = done.runnerUpId || null;
      state.tiebreak = done.tiebreakAnswerText
        ? { answeredKey: done.tiebreakAnswerKey, answeredText: done.tiebreakAnswerText }
        : null;
      mode = done.correctionMode || mode;
      // 同じ診断のログへ続けて記録できるよう、保存済みセッションを引き継ぐ
      session = S.logger.allLogs().find(l => l.sessionId === done.sessionId) || null;
      state.screen = "result";
      render();
      return;
    }
    state = freshState();
    render();
  }

  // ---- ブラウザ標準の戻る操作 ----
  window.addEventListener("popstate", e => {
    if (e.state && e.state.shindan && e.state.screen && state) {
      state.screen = e.state.screen;
      // 戻った画面に必要な入力がない場合は安全な画面へ丸める
      if (/^q[1-7]$/.test(state.screen) && state.entranceId == null) state.screen = "entrance";
      if (state.screen === "tiebreak" && !state.tiebreak) state.screen = "q7";
      if (state.screen === "result" && !state.resultId) state.screen = "start";
      if (state.screen === "map" && !state.resultId) state.screen = "start";
      if (state.screen === "survey" && !state.resultId) state.screen = "start";
      // モードで存在しない画面は結果画面へ丸める
      if (state.screen === "map" && appMode === "public") state.screen = "result";
      if (state.screen === "survey" && appMode !== "test") state.screen = "result";
      // 診断完了後は質問画面へ直接戻らない（結果画面で受け止める）
      if (state.resultId &&
          (/^q[1-7]$/.test(state.screen) || state.screen === "entrance" ||
           state.screen === "tiebreak")) {
        state.screen = "result";
      }
      suppressPush = true;
      persist(); render();
    }
  });

  function esc(s) {
    return String(s).replace(/[&<>"']/g,
      c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }

  // 二重クリック防止: 最初のタップで全選択肢を無効化
  function lockOpts() {
    document.querySelectorAll(".opt").forEach(b => { b.disabled = true; });
  }
  function logScreen(name) {
    if (session) {
      S.logger.logEvent(session, "screen_view", { screen: name });
      // 表示直後に離脱してもCSVの離脱位置が現在画面になるよう即時保存
      S.logger.commitSession(session);
    }
  }

  // ---- 共通描画部品 ----
  function shell(progressHtml, bodyHtml, footHtml) {
    app.innerHTML =
      '<header class="head"><div class="head-title">その決断を問う</div>' +
      '<div class="head-progress">' + (progressHtml || "") + "</div></header>" +
      '<main class="body">' + bodyHtml + "</main>" +
      '<footer class="foot">' + (footHtml || "") + "</footer>" +
      (DEBUG ? '<button id="btn-debug" class="debug-fab">DEBUG</button>' : "");
    const dbg = $("#btn-debug");
    if (dbg) dbg.onclick = () => renderDebug();
    window.scrollTo(0, 0);
  }
  function backBtn() {
    return '<button class="btn-back" id="btn-back">← 戻る</button>';
  }

  // ---- 画面1: 開始 ----
  function renderStart() {
    state = freshState();
    // タイトル: 画像があれば画像、読み込み失敗時は元のテキスト見出しへ自動フォールバック
    const titleImg = S.config.titleImage;
    const titleFallback =
      '<p class="start-ex">' + esc(S.config.exhibitionName) + "</p>" +
      '<h1 class="start-title">今のあなたに、<br>問いを投げかける武将は。</h1>';
    const titleHtml = titleImg
      ? '<img class="start-title-img" src="' + esc(titleImg) +
        '" alt="' + esc(S.config.exhibitionName) + '／今のあなたに、問いを投げかける武将は。"' +
        ' onerror="this.style.display=\'none\';document.getElementById(\'start-title-fb\').style.display=\'block\';">' +
        '<div id="start-title-fb" style="display:none">' + titleFallback + "</div>"
      : titleFallback;
    shell("",
      '<div class="start">' +
      titleHtml +
      '<p class="start-lead">迷いへの向き合い方から、26人の武将の中から1人を選び、' +
      "その武将の作品へご案内します。<br>所要時間は約2分・基本8問。" +
      // 芳名帳で任意の入力を受け取るため「取得しない」とは書かない
      "結果が近い場合のみ、最後にもう1問あります。<br>" +
      "診断に個人情報の入力は必要ありません。</p>" +
      (appMode === "test" ?
        '<p class="test-note">' + esc(S.config.testNote) + "</p>" : "") +
      '<button class="btn-primary" id="btn-start">診断をはじめる</button>' +
      "</div>", "");
    $("#btn-start").onclick = () => {
      session = S.logger.newSession(mode, appMode);
      S.logger.logEvent(session, "start", { mode });
      state.screen = "entrance";
      persist(); render();
    };
  }

  // ---- 画面2: 入口9択 ----
  function renderEntrance() {
    logScreen("entrance");
    const opts = S.entrances.map(e =>
      '<button class="opt" data-id="' + e.id + '">' + esc(e.text) + "</button>").join("");
    shell('<span>入口</span>',
      '<h2 class="q-text">いま、あなたの中にある迷いに、いちばん近いものを選んでください。</h2>' +
      '<div class="opts">' + opts + "</div>",
      backBtn());
    document.querySelectorAll(".opt").forEach(b => b.onclick = () => {
      lockOpts();
      state.entranceId = Number(b.dataset.id);
      S.logger.logEvent(session, "entrance_select", { entranceId: state.entranceId });
      state.screen = "q1";
      persist(); render();
    });
    $("#btn-back").onclick = () => { state.screen = "start"; persist(); render(); };
  }

  // ---- 画面3: 通常質問 n/7 ----
  function renderQuestion(n) {
    logScreen("q" + n);
    const q = S.questions[n - 1];
    const current = state.answers[q.id];  // 戻ってきた場合は選択済み表示
    const opts = q.options.map(o =>
      '<button class="opt' + (current === o.key ? " opt-selected" : "") +
      '" data-key="' + o.key + '">' + esc(o.text) + "</button>").join("");
    shell("<span>" + n + "／7</span>",
      '<h2 class="q-text">Q' + n + "．" + esc(q.text) + "</h2>" +
      '<div class="opts">' + opts + "</div>",
      backBtn());
    document.querySelectorAll(".opt").forEach(b => b.onclick = () => {
      lockOpts();
      state.answers[q.id] = b.dataset.key;
      S.logger.logEvent(session, "answer", { qid: q.id, optionKey: b.dataset.key });
      if (n < 7) { state.screen = "q" + (n + 1); persist(); render(); }
      else finishQuestions();
    });
    $("#btn-back").onclick = () => {
      if (n === 1) state.screen = "entrance";
      else state.screen = "q" + (n - 1);
      persist(); render();
    };
  }

  // ---- 判定 → 追加質問 or 結果 ----
  function finishQuestions() {
    const d = S.engine.diagnose(state.entranceId, state.answers, mode);
    if (d.needTiebreak) {
      const tq = S.engine.pickTiebreakQuestion(d.tiePair[0], d.tiePair[1]);
      state.tiebreak = { pair: d.tiePair, question: tq, answeredKey: null,
                        answeredText: null, reason: tq.reason,
                        scoreGap: (d.rows[0].score - d.rows[1].score) };
      S.logger.logEvent(session, "tiebreak_shown",
        { pair: d.tiePair, reason: tq.reason });
      state.screen = "tiebreak";
    } else {
      state.resultId = d.winner;
      const ru = d.rows.find(r => r.id !== d.winner);
      state.runnerUpId = ru ? ru.id : null;
      state.tiebreak = null;
      completeSession(d);
      state.screen = "result";
    }
    persist(); render();
  }

  // ---- 画面4: 追加質問（選び直し可・決定ボタンで確定）----
  function renderTiebreak() {
    logScreen("tiebreak");
    const tq = state.tiebreak.question;
    const opts = tq.options.map(o =>
      '<button class="opt" data-key="' + o.key + '" data-winner="' + o.winnerId + '">' +
      esc(o.text) + "</button>").join("");
    shell("<span>追加質問</span>",
      '<p class="tb-intro">' + esc(S.tiebreaks.intro) + "</p>" +
      '<h2 class="q-text">' + esc(tq.text) + "</h2>" +
      '<div class="opts">' + opts + "</div>" +
      '<button class="btn-primary" id="btn-tb-confirm" disabled>この回答で決定</button>' +
      '<p class="tb-hint">選び直しできます。「この回答で決定」で結果が表示されます。</p>', "");
    let chosen = null;
    document.querySelectorAll(".opt").forEach(b => b.onclick = () => {
      document.querySelectorAll(".opt").forEach(x => x.classList.remove("opt-selected"));
      b.classList.add("opt-selected");
      chosen = b;
      $("#btn-tb-confirm").disabled = false;
    });
    $("#btn-tb-confirm").onclick = () => {
      if (!chosen) return;
      $("#btn-tb-confirm").disabled = true;   // 二重確定防止
      lockOpts();
      state.tiebreak.answeredKey = chosen.dataset.key;
      state.tiebreak.answeredText = chosen.textContent;
      state.resultId = chosen.dataset.winner;
      state.runnerUpId = state.tiebreak.pair.find(id => id !== state.resultId) || null;
      S.logger.logEvent(session, "tiebreak_answer",
        { optionKey: state.tiebreak.answeredKey, winnerId: state.resultId });
      const d = S.engine.diagnose(state.entranceId, state.answers, mode);
      completeSession(d);
      state.screen = "result";
      persist(); render();
    };
  }

  function completeSession(diag) {
    S.logger.logEvent(session, "complete", {
      winnerId: state.resultId,
      runnerUpId: state.runnerUpId,
      tiebreakUsed: !!(state.tiebreak && state.tiebreak.answeredKey),
      lowSimilarityFallback: diag.lowSimilarityFallback
    });
    S.logger.commitSession(session);

    // 芳名帳用に、確定した診断結果を保存する。
    // 再読み込みしても同じ武将を復元でき、送信時はこの回答からサーバーが再判定する。
    S.logger.saveResult({
      sessionId: session.sessionId,
      entranceId: state.entranceId,
      answers: Object.assign({}, state.answers),
      tiebreakAnswerKey: (state.tiebreak && state.tiebreak.answeredKey) || "",
      tiebreakAnswerText: (state.tiebreak && state.tiebreak.answeredText) || "",
      correctionMode: mode,
      appMode: appMode,
      resultId: state.resultId,
      runnerUpId: state.runnerUpId,
      completedAt: Date.now(),
      registered: false
    });
  }

  // ---- 芳名帳（結果画面の下部・個展の来場記録）----
  const GB_OK_TEXT =
    "ご来場ありがとうございました。あなたの決断とともに、お名前を記録しました。";
  const GB_OK_TEXT_PUBLIC =
    "ご登録ありがとうございました。新作やお知らせを、こちらへお送りします。";
  const GB_MAIL_FAIL_TEXT =
    "来場記録は完了しましたが、診断結果メールを送信できませんでした。";
  const GB_MAIL_FAIL_TEXT_PUBLIC =
    "ご登録は完了しましたが、診断結果メールを送信できませんでした。";

  // 登録済み・登録直後に表示する内容
  function guestbookDoneHtml(mailFailed) {
    const pub = appMode === "public";
    return "<h3>" + (pub ? "登録が完了しました" : "来場の記録") + '</h3><p class="gb-done">' +
      esc(pub ? GB_OK_TEXT_PUBLIC : GB_OK_TEXT) + "</p>" +
      (mailFailed ? '<p class="gb-msg gb-msg-warn">' +
        esc(pub ? GB_MAIL_FAIL_TEXT_PUBLIC : GB_MAIL_FAIL_TEXT) + "</p>" : "");
  }

  // 入力フォーム。武将の入力欄・選択欄は設けない（結果から自動で紐づけるため）。
  function guestbookFormHtml() {
    const g = S.config.guestbook;
    const w = state.resultId ? S.engine.byId(state.resultId) : null;
    const pub = appMode === "public";
    const head = !pub ? "ご来場の記念に、お名前をお残しください。"
      : (w && !w.shopUrl) ? w.name + "のアイテムができたら、最初にお知らせします。"
      : "新作やお知らせを受け取る";
    const lead = !pub ? "診断結果をメールで受け取りたい方は、メールアドレスもご入力ください。"
      : "診断結果をメールで受け取りたい方は、メールアドレスもご入力ください。";
    return "<h3>" + esc(head) + "</h3>" +
      '<p class="gb-lead">' + esc(lead) + "</p>" +
      '<label class="gb-label" for="gb-name">お名前またはニックネーム' +
      '<span class="gb-req">必須</span></label>' +
      '<input class="gb-input" id="gb-name" type="text" autocomplete="name" ' +
      'maxlength="' + (g.nameMaxLength || 40) + '" placeholder="例：山田 太郎">' +
      '<label class="gb-label" for="gb-email">メールアドレス' +
      '<span class="gb-opt">任意</span></label>' +
      '<input class="gb-input" id="gb-email" type="email" autocomplete="email" ' +
      'inputmode="email" placeholder="example@example.com">' +
      '<label class="gb-check" for="gb-consent">' +
      '<input type="checkbox" id="gb-consent">' +
      "<span>Yoshikuniから、" + (appMode === "public" ? "新作やお知らせ" : "今後の展示や新作に関する案内") +
      "を受け取る</span></label>" +
      '<p class="gb-note">ご入力いただいた情報は、' +
      (pub ? "ご登録の記録" : "来場記録") + "および希望者への診断結果送信に" +
      "使用します。案内メールは、配信に同意された方にのみお送りします。" +
      (g.privacyPolicyUrl ?
        '<br><a class="gb-link" href="' + esc(g.privacyPolicyUrl) +
        '" target="_blank" rel="noopener">プライバシーポリシー</a>' : "") + "</p>" +
      '<button class="btn-primary" id="gb-submit">' +
      (appMode === "public" ? "登録する" : "来場の記録を残す") + "</button>" +
      '<p class="gb-msg" id="gb-msg" role="status" aria-live="polite"></p>';
  }

  // 保存済みの診断結果を返す。画面の結果と一致しない場合は登録させない。
  function guestbookResult() {
    const done = S.logger.loadResult();
    if (!done || !done.resultId || done.resultId !== state.resultId) return null;
    return done;
  }

  function guestbookSectionHtml() {
    const done = guestbookResult();
    if (!S.guestbook.isAvailable(appMode, !!done)) return "";
    return '<section class="r-sec gb" id="gb-sec">' +
      (done.registered ? guestbookDoneHtml(false) : guestbookFormHtml()) + "</section>";
  }

  // フォームの操作。個人情報はコンソールへ出力しない。
  function bindGuestbook() {
    const btn = $("#gb-submit");
    if (!btn) return;
    const nameEl = $("#gb-name"), mailEl = $("#gb-email"),
          consentEl = $("#gb-consent"), msgEl = $("#gb-msg"), sec = $("#gb-sec");
    let sending = false;
    function setMsg(text, kind) {
      msgEl.textContent = text;
      msgEl.className = "gb-msg" + (kind ? " gb-msg-" + kind : "");
    }
    // メールアドレスがないまま同意された場合は、その場で案内する
    consentEl.onchange = () => {
      if (consentEl.checked && !mailEl.value.trim()) {
        setMsg("案内を受け取るにはメールアドレスをご入力ください。", "warn");
      } else if (msgEl.className.indexOf("gb-msg-warn") >= 0) {
        setMsg("", "");
      }
    };
    btn.onclick = () => {
      if (sending) return;                       // 連打による二重登録を防ぐ
      const done = guestbookResult();
      if (!done) { setMsg("診断結果が確認できません。もう一度診断してください。", "warn"); return; }
      const v = S.guestbook.validate(nameEl.value, mailEl.value, consentEl.checked);
      if (!v.ok) { setMsg(v.error, "warn"); return; }
      sending = true;
      btn.disabled = true;
      setMsg("送信しています…", "");
      S.logger.logEvent(session, "guestbook_submit",
        { hasEmail: !!v.email, consent: v.consent });
      S.logger.commitSession(session);
      S.guestbook.submit(done, v).then(res => {
        if (!res || !res.ok) throw new Error("server_error");
        S.logger.markResultRegistered();
        S.logger.logEvent(session, "guestbook_saved",
          { warlordId: res.warlordId || "", mailSent: !!res.mailSent });
        S.logger.commitSession(session);
        sec.innerHTML = guestbookDoneHtml(!!v.email && !res.mailSent);
        sec.scrollIntoView({ block: "center" });
      }).catch(() => {
        // 保存できたか分からないため登録済みにはしない。
        // サーバーは診断セッションIDで重複を排除するので、送り直しても行は増えない。
        sending = false;
        btn.disabled = false;
        setMsg("通信に失敗しました。電波の良い場所で、もう一度お試しください。", "warn");
      });
    };
  }

  // ---- 画面5: 結果 ----
  function renderResult() {
    logScreen("result");
    const w = S.engine.byId(state.resultId);
    const zone = S.zones[w.zone];
    const ent = S.entrances.find(e => e.id === state.entranceId);
    const reason = S.reason.buildReason(state.entranceId, state.answers,
      state.resultId, state.runnerUpId, state.tiebreak);
    S.logger.logEvent(session, "result_view", { winnerId: w.id });
    S.logger.commitSession(session);

    shell("<span>結果</span>",
      '<div class="result">' +
      '<p class="r-lead">今のあなたに、問いを投げかける武将は――</p>' +
      '<h1 class="r-name">' + esc(w.name) + "</h1>" +
      (w.intro ? '<p class="r-intro">' + esc(w.intro) + "</p>" : "") +
      '<div class="r-toi">' + esc(w.toi) + "</div>" +
      '<section class="r-sec"><h3>いまのあなた</h3><p>' +
      esc(ent ? ent.youText : "") + "</p></section>" +
      '<section class="r-sec"><h3>なぜこの武将か</h3>' +
      reason.lines.map(l => "<p>" + esc(l) + "</p>").join("") + "</section>" +
      '<section class="r-sec"><h3>この武将が示す視点</h3><p>' + esc(w.you) + "</p></section>" +
      '<section class="r-sec"><h3>この武将の決断</h3><p>' + esc(w.decision) + "</p></section>" +
      // 展示会・テスト: 展示位置とマップ ／ 一般公開: 関連アイテム・共有・ブランド導線
      (appMode !== "public" ?
        '<section class="r-sec r-place"><h3>展示へ</h3>' +
        "<p><strong>" + esc(zone.label) + "</strong><br>" + esc(w.invite) + "</p>" +
        '<button class="btn-secondary" id="btn-map">会場内の展示位置を見る</button></section>'
        :
        (w.shopUrl
          ? '<section class="r-sec"><h3>関連アイテム</h3>' +
            "<p>" + esc(w.name) + "の問いと決断を、タイポグラフィ作品やアイテムでも。</p>" +
            '<a class="btn-secondary" id="btn-shop" href="' + esc(w.shopUrl) +
            '">' + esc(w.name) + 'のアイテムを見る</a></section>'
          : '<section class="r-sec"><h3>' + esc(w.name) + 'のアイテム</h3>' +
            "<p>" + esc(w.name) + "のアイテムは、いま制作中です。<br>" +
            "できあがったら、ご登録の方へ最初にお知らせします。</p></section>") +
        '<section class="r-sec"><h3>共有</h3>' +
        '<button class="btn-secondary" id="btn-share">この結果を共有する</button></section>'
      ) +
      '<section class="r-sec"><h3>結果を保存</h3>' +
      '<div id="save-area"></div>' +
      '<button class="btn-primary" id="btn-save">結果画像をつくる</button></section>' +
      guestbookSectionHtml() +
      '<button class="btn-tert" id="btn-retry">もう一度診断する</button>' +
      (appMode === "public" ?
        '<a class="btn-tert" href="' + esc(S.config.publicLinks.brand) +
        '">Yoshikuni について</a>' : "") +
      "</div>", "");
    if (appMode !== "public") {
      $("#btn-map").onclick = () => {
        S.logger.logEvent(session, "map_tap", { winnerId: w.id });
        S.logger.commitSession(session);
        state.screen = "map";
        persist(); render();
      };
    } else {
      // 商品が未制作の武将には「この武将のアイテムを見る」が存在しない
      const shopBtn = $("#btn-shop");
      if (shopBtn) {
        shopBtn.addEventListener("click", () => {
          S.logger.logEvent(session, "shop_tap", { winnerId: w.id });
          S.logger.commitSession(session);
        });
      }
      $("#btn-share").onclick = () => {
        S.logger.logEvent(session, "share_tap", { winnerId: w.id });
        S.logger.commitSession(session);
        const url = location.origin + location.pathname;
        const text = "今の私に、問いを投げかける武将は――" + w.name + "。「" +
          w.toi + "」 #その決断を問う";
        if (navigator.share) {
          navigator.share({ title: shareTitle(), text, url })
            .catch(() => {});
        } else {
          window.open("https://twitter.com/intent/tweet?text=" +
            encodeURIComponent(text + " " + url), "_blank");
        }
      };
    }
    $("#btn-save").onclick = () => {
      S.logger.logEvent(session, "save_tap", { winnerId: w.id });
      S.logger.commitSession(session);
      makeSaveImage(w, zone);
    };
    bindGuestbook();
    $("#btn-retry").onclick = () => {
      S.logger.clearState();
      S.logger.clearResult();   // 前回の結果で芳名登録できないようにする
      state = freshState(); session = null;
      render();
    };
    S.logger.clearState(); // 完了後は途中復元しない
  }

  // 共有シートの件名。一般公開では芳名帳の取得元名（戦国武将診断『その決断を問う』）に揃える
  function shareTitle() {
    const po = (S.config.guestbook || {}).publicOrigin || {};
    return appMode === "public" ? (po.eventName || S.config.exhibitionName)
      : S.config.exhibitionName;
  }

  // ---- 保存画像（仮レイアウト・canvas生成）----
  function makeSaveImage(w, zone) {
    const cv = document.createElement("canvas");
    cv.width = 750; cv.height = 1000;
    const ctx = cv.getContext("2d");
    ctx.fillStyle = "#14120f"; ctx.fillRect(0, 0, 750, 1000);
    ctx.strokeStyle = "#b79b52"; ctx.lineWidth = 4;
    ctx.strokeRect(24, 24, 702, 952);
    ctx.fillStyle = "#cfc6b3"; ctx.font = "26px serif"; ctx.textAlign = "center";
    ctx.fillText(appMode === "public"
      ? ((S.config.publicSaveImage || {}).brand || S.config.exhibitionName)
      : S.config.exhibitionName, 375, 110);
    ctx.fillStyle = "#f4efe3"; ctx.font = "bold 72px serif";
    ctx.fillText(w.name, 375, 330);
    // 問い（長い場合は2行に分割）
    ctx.fillStyle = "#e8d9ae"; ctx.font = "34px serif";
    const toi = w.toi;
    if (toi.length > 18) {
      const mid = Math.ceil(toi.length / 2);
      let cut = toi.indexOf("。", 5);
      if (cut < 0 || cut > toi.length - 3) cut = mid;
      else cut = cut + 1;
      ctx.fillText(toi.slice(0, cut), 375, 470);
      ctx.fillText(toi.slice(cut), 375, 525);
    } else {
      ctx.fillText(toi, 375, 490);
    }
    if (appMode !== "public") {
      // 展示会・テスト: 展示位置を記載
      ctx.fillStyle = "#cfc6b3"; ctx.font = "28px sans-serif";
      ctx.fillText("展示位置", 375, 690);
      ctx.font = "bold 30px sans-serif"; ctx.fillStyle = "#f4efe3";
      ctx.fillText(zone.label, 375, 735);
    } else {
      // 一般公開: 会場情報の代わりに、診断そのものの案内を置く
      const si = S.config.publicSaveImage || {};
      ctx.fillStyle = "#cfc6b3"; ctx.font = "26px sans-serif";
      ctx.fillText(si.label || "", 375, 690);
      ctx.font = "bold 34px sans-serif"; ctx.fillStyle = "#f4efe3";
      ctx.fillText(si.title || "", 375, 737);
    }
    ctx.font = "22px sans-serif"; ctx.fillStyle = "#8f8874";
    if (appMode === "public") {
      ctx.fillText((S.config.publicSaveImage || {}).footer || S.config.publicUrlLabel, 375, 900);
    } else {
      ctx.fillText(S.config.returnInfo, 375, 900);
      ctx.fillText("診断ロジック " + S.config.version, 375, 935);
    }

    const url = cv.toDataURL("image/png");
    $("#save-area").innerHTML =
      '<img class="save-img" src="' + url + '" alt="結果画像">' +
      '<p class="save-hint">画像を長押し（またはダウンロードボタン）で保存できます。</p>' +
      '<a class="btn-secondary dl" download="shindan_' + w.id + '.png" href="' + url +
      '">画像をダウンロード</a>';
  }

  // ---- 画面6: 会場マップ ----
  function renderMap() {
    logScreen("map");
    const w = state.resultId ? S.engine.byId(state.resultId) : null;
    const zoneRows = Object.entries(S.zones).map(([key, z]) => {
      const names = S.warlords.filter(x => x.zone === key).map(x => x.name).join("・");
      const hit = w && w.zone === key;
      return '<div class="zone' + (hit ? " zone-hit" : "") + '">' +
        "<strong>" + esc(z.label) + "</strong><br><span>" + esc(names) + "</span></div>";
    }).join("");
    shell("<span>展示位置</span>",
      '<h2 class="q-text">会場内の展示位置</h2>' +
      (w ? '<p class="map-lead">' + esc(w.name) + "は <strong>" +
        esc(S.zones[w.zone].label) + "</strong> にあります。</p>" : "") +
      '<div class="zones">' + zoneRows + "</div>",
      '<button class="btn-back" id="btn-back">← 結果へ戻る</button>');
    $("#btn-back").onclick = () => { state.screen = "result"; persist(); render(); };
  }

  // ---- 画面: テスト後アンケート（testモードのみ）----
  function renderSurvey() {
    logScreen("survey");
    if (!state.survey) state.survey = { answers: {}, items: [], done: false };
    const sv = state.survey;
    if (sv.done) {
      shell("<span>アンケート</span>",
        '<div class="start"><h2 class="q-text">' + esc(S.survey.thanks) + "</h2>" +
        '<button class="btn-primary" id="btn-back-result">結果へ戻る</button></div>', "");
      $("#btn-back-result").onclick = () => { state.screen = "result"; persist(); render(); };
      return;
    }
    let body = '<p class="tb-intro">' + esc(S.survey.intro) + "</p>";
    for (const q of S.survey.questions) {
      body += '<div class="s-q"><h2 class="s-q-text">' + esc(q.text) + "</h2>" +
        '<div class="opts">' +
        q.options.map(o =>
          '<button class="opt s-opt' + (sv.answers[q.id] === o ? " opt-selected" : "") +
          '" data-q="' + q.id + '" data-v="' + esc(o) + '">' + esc(o) + "</button>").join("") +
        "</div>";
      if (q.followUp && sv.answers[q.id] === q.followUp.trigger) {
        body += '<p class="s-fu-text">' + esc(q.followUp.text) + "</p>" +
          '<div class="s-chks">' +
          q.followUp.items.map(it =>
            '<button class="s-chk' + (sv.items.includes(it) ? " on" : "") +
            '" data-item="' + esc(it) + '">' + esc(it) + "</button>").join("") +
          "</div>";
      }
      body += "</div>";
    }
    const allAnswered = S.survey.questions.every(q => sv.answers[q.id]);
    body += '<button class="btn-primary" id="btn-sv-submit"' +
      (allAnswered ? "" : " disabled") + ">送信する</button>";
    shell("<span>アンケート</span>", body,
      '<button class="btn-back" id="btn-back">← 結果へ戻る</button>');
    document.querySelectorAll(".s-opt").forEach(b => b.onclick = () => {
      sv.answers[b.dataset.q] = b.dataset.v;
      persist(); render();
    });
    document.querySelectorAll(".s-chk").forEach(b => b.onclick = () => {
      const it = b.dataset.item;
      const i = sv.items.indexOf(it);
      if (i >= 0) sv.items.splice(i, 1); else sv.items.push(it);
      persist(); render();
    });
    $("#btn-sv-submit").onclick = () => {
      if (!S.survey.questions.every(q => sv.answers[q.id])) return;
      $("#btn-sv-submit").disabled = true;   // 二重送信防止
      S.logger.logEvent(session, "survey_submit", {
        s1: sv.answers.s1, s2: sv.answers.s2, s3: sv.answers.s3,
        s4: sv.answers.s4, s5: sv.answers.s5,
        s5items: sv.answers.s5 === "あった" ? sv.items.slice() : []
      });
      S.logger.commitSession(session);
      sv.done = true;
      persist(); render();
    };
    $("#btn-back").onclick = () => { state.screen = "result"; persist(); render(); };
  }

  // ---- 復元確認 ----
  function renderResume() {
    shell("",
      '<div class="start"><h2 class="q-text">前回の診断が途中です。</h2>' +
      '<button class="btn-primary" id="btn-continue">続きから再開する</button>' +
      '<button class="btn-tert" id="btn-restart">最初からやり直す</button></div>', "");
    $("#btn-continue").onclick = () => render();
    $("#btn-restart").onclick = () => {
      S.logger.clearState();
      state = freshState(); session = null; render();
    };
  }

  // ---- 画面7: デバッグ ----
  function renderDebug() {
    const hasInput = state.entranceId != null &&
      Object.keys(state.answers).length > 0;
    let body = '<h2 class="q-text">デバッグ画面</h2>' +
      '<p class="dbg-meta">ロジック ' + esc(S.config.version) +
      "／分布補正モード: <strong>" + mode + "</strong>" +
      "／運用モード: <strong>" + appMode + "</strong>" +
      "（切替は ?appmode=test|exhibition|public＋?debug=1 が必要）</p>" +
      '<div class="dbg-modes">' +
      ["A", "B", "C"].map(m =>
        '<button class="btn-mode' + (m === mode ? " on" : "") + '" data-m="' + m + '">' +
        m + (m === "A" ? "（補正なし）" : m === "B" ? "（±6）" : "（±3）") +
        "</button>").join("") + "</div>";

    if (!hasInput) {
      body += '<p class="dbg-empty">まだ回答がありません。診断を進めてから開くと、' +
        "判定の内訳がここに表示されます。</p>";
    } else {
      const cmp = S.engine.compareModes(state.entranceId, state.answers);
      const d = cmp[mode];
      const ent = S.entrances.find(e => e.id === state.entranceId);
      body += '<section class="r-sec"><h3>入口の選択</h3><p>入口' +
        state.entranceId + "：" + esc(ent.text) + "</p></section>";
      body += '<section class="r-sec"><h3>回答</h3><p>' +
        S.questions.map(q => "Q" + q.id + "＝" + (state.answers[q.id] || "—"))
          .join("　") + "</p></section>";
      body += '<section class="r-sec"><h3>6軸ユーザーベクトル／信頼度</h3>' +
        '<table class="tbl"><tr><th>軸</th><th>値</th><th>信頼度</th></tr>' +
        S.axes.order.map(k =>
          "<tr><td>" + k + "（" + S.axes.defs[k].name + "）</td><td>" +
          d.vec[k].toFixed(2) + "</td><td>" + d.conf[k].toFixed(2) + "</td></tr>"
        ).join("") + "</table></section>";
      body += '<section class="r-sec"><h3>上位5武将（モード' + mode + "）</h3>" +
        '<table class="tbl"><tr><th>#</th><th>武将</th><th>類似度</th>' +
        "<th>入口</th><th>補正</th><th>最終</th></tr>" +
        d.rows.slice(0, 5).map((r, i) =>
          "<tr><td>" + (i + 1) + "</td><td>" + esc(r.name) + "</td><td>" +
          r.sim.toFixed(1) + "</td><td>" + r.entry + "</td><td>" +
          r.corr.toFixed(1) + "</td><td><strong>" + r.score.toFixed(1) +
          "</strong></td></tr>").join("") + "</table>" +
        (d.lowSimilarityFallback ?
          '<p class="dbg-warn">どの武将プロフィールとも十分に近くない（類似度55未満）ため、' +
          "入口候補群から選択</p>" : "") +
        "</section>";
      body += '<section class="r-sec"><h3>分布補正 3モード比較（1位〜3位）</h3>' +
        '<table class="tbl"><tr><th>モード</th><th>1位</th><th>2位</th><th>3位</th>' +
        "<th>1-2位差</th></tr>" +
        ["A", "B", "C"].map(m => {
          const r = cmp[m].rows;
          return "<tr><td>" + m + "</td><td>" + esc(r[0].name) + "</td><td>" +
            esc(r[1].name) + "</td><td>" + esc(r[2].name) + "</td><td>" +
            (r[0].score - r[1].score).toFixed(2) + "</td></tr>";
        }).join("") + "</table></section>";
      if (state.tiebreak) {
        body += '<section class="r-sec"><h3>追加質問</h3><p>発動理由: 1-2位差 ' +
          state.tiebreak.scoreGap.toFixed(2) + "点 ＜ しきい値" +
          S.config.tieGap + "<br>方式: " + esc(state.tiebreak.reason) +
          (state.tiebreak.answeredText ?
            "<br>回答: 「" + esc(state.tiebreak.answeredText) + "」→ 結果 " +
            esc(S.engine.nameOf(state.resultId)) : "<br>（未回答）") +
          "</p></section>";
      } else {
        body += '<section class="r-sec"><h3>追加質問</h3><p>発動せず（1-2位差 ' +
          (d.rows[0].score - d.rows[1].score).toFixed(2) + "点）</p></section>";
      }
      if (state.resultId) {
        const rr = S.reason.buildReason(state.entranceId, state.answers,
          state.resultId, state.runnerUpId, state.tiebreak);
        body += '<section class="r-sec"><h3>結果理由に採用した回答</h3><p>' +
          (rr.picked.length ?
            rr.picked.map(p => "Q" + p.qid + "（" + p.optionKey + "・" + p.axis +
              "軸・勝者一致" + p.alignWinner.toFixed(2) +
              "・判別寄与" + p.contrib.toFixed(2) + "）").join("　") :
            "採用なし（回答全体の傾向として説明）") +
          (rr.usedFallbackNote ? "<br>※判別寄与の高い回答がないため、断定しない説明を使用" : "") +
          "<br>2位（判別対象）: " +
          (state.runnerUpId ? esc(S.engine.nameOf(state.runnerUpId)) : "—") +
          "</p></section>";
      }
    }
    const n = S.logger.allLogs().length;
    body += '<section class="r-sec"><h3>匿名ログ（' + n + "件）</h3>" +
      '<div class="dbg-btns">' +
      '<button class="btn-secondary" id="btn-json">JSON書き出し</button>' +
      '<button class="btn-secondary" id="btn-csv">CSV書き出し</button>' +
      '<button class="btn-tert" id="btn-clearlog">ログを消去</button></div></section>';

    shell("<span>DEBUG</span>", body,
      '<button class="btn-back" id="btn-back">← 診断へ戻る</button>');
    document.querySelectorAll(".btn-mode").forEach(b => b.onclick = () => {
      mode = b.dataset.m;
      if (session) session.correctionMode = mode;
      // 判定済みかつ追加質問未使用なら、現モードで再判定して結果を更新
      if (state.resultId && !(state.tiebreak && state.tiebreak.answeredKey)) {
        const d = S.engine.diagnose(state.entranceId, state.answers, mode);
        if (!d.needTiebreak) {
          state.resultId = d.winner;
          const ru = d.rows.find(r => r.id !== d.winner);
          state.runnerUpId = ru ? ru.id : null;
        }
      }
      persist(); renderDebug();
    });
    $("#btn-back").onclick = () => render();
    $("#btn-json").onclick = () =>
      S.logger.download("shindan_logs.json", S.logger.exportJSON(), "application/json");
    $("#btn-csv").onclick = () => {
      const csv = S.logger.exportCSV();
      if (csv) S.logger.download("shindan_logs.csv", "﻿" + csv, "text/csv");
    };
    $("#btn-clearlog").onclick = () => { S.logger.clearLogs(); renderDebug(); };
  }

  // ---- ルーター ----
  function render() {
    try {
      const s = state.screen;
      if (s === "start") renderStart();
      else if (s === "entrance") renderEntrance();
      else if (/^q[1-7]$/.test(s)) renderQuestion(Number(s.slice(1)));
      else if (s === "tiebreak") renderTiebreak();
      else if (s === "result") renderResult();
      else if (s === "map") {
        if (appMode === "public") { state.screen = "result"; renderResult(); }
        else renderMap();
      }
      else if (s === "survey") {
        if (appMode !== "test") { state.screen = "result"; renderResult(); }
        else renderSurvey();
      }
      else renderStart();
      // ブラウザ履歴へ画面を積む（popstate復帰時と同一画面の連続は積まない）
      if (!suppressPush && state.screen !== lastPushedScreen) {
        history.pushState({ screen: state.screen, shindan: true }, "");
      }
      lastPushedScreen = state.screen;
      suppressPush = false;
    } catch (err) {
      // 白画面防止
      app.innerHTML = '<main class="body"><h2>エラーが発生しました</h2>' +
        "<p>お手数ですが、下のボタンからやり直してください。</p>" +
        '<button class="btn-primary" id="btn-reset">最初からやり直す</button>' +
        '<pre class="err">' + esc(err && err.message || err) + "</pre></main>";
      $("#btn-reset").onclick = () => {
        S.logger.clearState(); state = freshState(); session = null; render();
      };
    }
  }

  boot();
})();

